




























































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { Cities } from '@/store'

interface Content {
  school: string
  areaCode: string
  area: string
  sizeIndex: number
  size: string
  chief: string
  phone: string
}

@Component
export default class extends Vue {
  private showAreaPicker: boolean = false
  private showSizePicker: boolean = false
  private content: Partial<Content> = {}
  private errors: Partial<Record<keyof Content, boolean>> = {}

  @Prop({ type: Array, required: true })
  sizes: string[]

  @Prop({ type: Object, required: true })
  areaList: Cities

  onConfirmSize(value: string, index: number) {
    this.showSizePicker = false
    this.content.sizeIndex = index
    this.content.size = value
    this.onReset('size')
  }

  onConfirmArea(value: Array<{ code: string; name: string }>) {
    this.showAreaPicker = false
    this.content.areaCode = value[2] ? value[2].code : value[1].code
    this.content.area = value
      .filter(i => i)
      .map(i => i.name)
      .join(' ')
    this.onReset('areaCode')
  }

  getContainer() {
    return document.body
  }

  async onSubmit() {
    const msg = this.validate()
    if (msg) {
      this.$toast(msg)
    } else {
      this.onSuccess()
    }
  }

  validate() {
    const { school, areaCode, size, chief, phone } = this.content
    this.errors = {
      school: !school,
      areaCode: !areaCode,
      size: !size,
      chief: !chief || chief.length < 2 || chief.length > 6,
      phone: !phone || phone.length !== 11
    }
    if (!school) {
      return '请填写学校名称'
    }
    if (!areaCode) {
      return '请选择学校所在的省市区'
    }
    if (!size) {
      return '请选择学员总数'
    }
    if (!chief) {
      return '请填写负责人真实姓名'
    }
    if (chief.length < 2 || chief.length > 6) {
      return '学校负责人姓名有误'
    }
    if (!phone) {
      return '请填写负责人11位手机号码'
    }
    if (phone.length !== 11) {
      return '负责人手机有误'
    }
    // if (/^(1[3-9])\d{9}$/.test(phone)) {
    //   return '负责人手机有误'
    // }
  }

  phoneFormatter(value: string) {
    return value.replace(/[^\d]/g, '')
  }

  schoolFormatter(value: string) {
    return value.replace(/[^\u4e00-\u9fa5a-zA-Z\d]/g, '')
  }

  nameFormatter(value: string) {
    return value.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '')
  }

  @Emit('submit')
  onSuccess() {
    return this.content
  }

  onReset(key: keyof Content) {
    this.errors[key] = false
  }
}
